<template>
  <div>
    <v-toolbar dense class="toolbar-style hide-on-print">
      <router-link to="/home" class="title-link hide-on-mobile">
        <v-toolbar-title class="">GINGERGRACE ACADEME</v-toolbar-title>
      </router-link>
      <v-spacer class="hide-on-mobile"></v-spacer>

      <v-menu
         :close-on-content-click="false"
         :nudge-width="300"
         offset-y
       >
         <template v-slot:activator="{ on }">
           <v-btn icon dark v-on="on">
            <v-icon>menu</v-icon>
          </v-btn>
         </template>
         <v-card style="text-align: center;">
           <v-list>
             <v-list-tile>
               <v-layout row wrap>
                <v-flex class="tool-nav-button">
                  <router-link to="/home">
                    <div class="nav-icons"><v-icon large>payment</v-icon><p style="margin-bottom: 0;">Payments</p></div>
                  </router-link>
                </v-flex>
                <v-divider
                  class="mx-3 hide-on-mobile"
                  inset
                  vertical
                >
                </v-divider>
                 <v-flex class="tool-nav-button">
                  <router-link to="/student-list">
                   <div class="nav-icons"><v-icon large>people</v-icon><p style="margin-bottom: 0;">Students</p></div>
                  </router-link>
                </v-flex>
                <v-divider
                class="mx-3 hide-on-mobile"
                inset
                vertical
                >
              </v-divider>
              <v-flex class="tool-nav-button">
                <router-link to="/statistics">
                  <div class="nav-icons"><v-icon large>mdi-chart-bar</v-icon><p style="margin-bottom: 0;">Statistics</p></div>
                </router-link>
              </v-flex>
                <v-divider
                  class="mx-3 hide-on-mobile"
                  inset
                  vertical
                >
                </v-divider>
                <v-flex class="tool-nav-button">
                  <router-link to="/templates">
                    <div class="nav-icons"><v-icon large>settings</v-icon><p style="margin-bottom: 0;">Templates</p></div>
                  </router-link>
                </v-flex>
                <v-divider
                  class="mx-3 hide-on-mobile"
                  inset
                  vertical
                >
                </v-divider>
                <v-flex class="tool-nav-button">
                  <router-link to="/message">
                    <div class="nav-icons"><v-icon large>mdi-comment-text</v-icon><p style="margin-bottom: 0;">Send SMS</p></div>
                  </router-link>
                </v-flex>

                <v-divider
                  class="mx-3 hide-on-mobile"
                  inset
                  vertical
                >
                </v-divider>
                <v-flex class="tool-nav-button">
                  <router-link to="/due-payments">
                    <div class="nav-icons"><v-icon large>mdi-calendar-clock</v-icon><p style="margin-bottom: 0;">Due Payments</p></div>
                  </router-link>
                </v-flex>

                <v-divider
                  class="mx-3 hide-on-mobile"
                  inset
                  vertical
                >
                </v-divider>

                <v-flex class="tool-nav-button">
                  <router-link to="/online-enrollments">
                    <div class="nav-icons"><v-icon large>mdi-web</v-icon><p style="margin-bottom: 0;">Online Enrollments</p></div>
                  </router-link>
                </v-flex>

               </v-layout>
             </v-list-tile>
           </v-list>
         </v-card>
      </v-menu>
      <v-spacer class="mobile-only"></v-spacer>
      <v-menu
        offset-y
        content-class="dropdown-menu"
        transition="slide-y-transition">
        <v-btn
        slot="activator"
        color="transparent white--text"
        >
        <v-icon left>face</v-icon>
          <span v-if="admin">{{ admin.user.first_name }} {{ admin.user.last_name }} ({{ admin.user.username }})</span>
        </v-btn>
        <v-card>
         <v-list>
            <v-list-tile @click="editUser">
                <v-list-tile-title class="link-color">Profile</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="">
              <v-list-tile-title class="link-color">
                <ChangePasswordModal />
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="">
              <v-list-tile-title @click.stop="dialog = true" class="link-color">Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>

    </v-toolbar>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title>Are you sure you want logout ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="button-style-blue" @click.prevent="confirmLogoutForm()">Logout</v-btn>
          <v-btn color="#091D3B" outline @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ChangePasswordModal from '@/components/ChangePasswordModal.vue'

export default {
  name: "Header",
  components: {
    ChangePasswordModal
  },
  computed: {
    ...mapState(['admin']),
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapActions(["logout"]),
    confirmLogoutForm () {
      let self = this
      this.logout()
        .then(() => {
          self.$toastr("success", "Logout Successfully", "")
          self.$router.push({ name: "login" });
          self.dialog = false
        })
        .catch((error) => {
          self.$toastr("error", error, "error")
          self.$router.push({ name: "login" });
        })
    },
    editUser() {
      this.$router.push({ name: 'admin-profile', params: {id: this.admin.user.id} })
    }
  }
}
</script>
